<template>
  <div>
    <b-form>
      <b-row class="mt-4">
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Name</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-input id="input-1" v-model="usersCreateForm.name"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Username</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
              label-for="input-1"
          >
            <b-form-input
                id="input-1"
                :state="usernameStatus"
                v-model="usersCreateForm.username"
            ></b-form-input>
            <b-form-invalid-feedback :state="usernameStatus">
              Please enter a valid username
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
        <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Carrier</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-select
              id="userGroup"
              v-model="usersCreateForm.customerGroup"
              :options="groupOption"
              :state="customerGroupStatus"
              value-field="key"
              class="mt-2 mb-0"
              text-field="label"
            ></b-form-select>
            <b-form-invalid-feedback :state="customerGroupStatus">
              Please select a valid Carrier.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Phone No</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
            label-for="input-1"
            class="country-code"
          >
            <vue-tel-input
              v-model="usersCreateForm.phoneNo"
              placeholder="201-555-2123"
              :defaultCountry="preferredCountry"
              :enabledCountryCode="enabledCountryCodeStatus"
              :state="phoneNoStatus"
              :validCharactersOnly="validCharactersOnly"
              @country-changed="onSelect"
            ></vue-tel-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Email</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="emailStatus"
              v-model="usersCreateForm.email"
            ></b-form-input>
            <b-form-invalid-feedback :state="emailStatus">
              Please enter a valid email.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Password</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              type="password"
              :state="passwordStatus"
              v-model="usersCreateForm.password"
            ></b-form-input>
            <b-form-invalid-feedback v-if="!passwordLength">
              Your password must have at least 8 chars.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!passwordUppercase">
              Your password must have at least 1 upper case letter.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!passwordNumber">
              Your password must have at least 1 number.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!passwordCharacter">
              Your password must have at least 1 special char.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <div class="mt-3 d-flex justify-content-between">
        <base-button type="white" title="Close"  v-on:click="modalClose()">
          Close
        </base-button>
        <base-button type="primary" :title="submitDisabled? '' : 'Save'" :disabled="submitDisabled" v-on:click="usersCreateSubmit" :loading="submitLoading">
            Save
        </base-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import administratorService from "../../common/api-services/administrator-service";
import handleResponse from "../../common/directive/handlResponse";
import AdministratorService from "@/common/api-services/administrator-service";

export default {
  name: "Users-Create",
  components: {
    VueTelInput
  },
  computed: {
    submitDisabled() {
      return !(this.customerGroupStatus && this.phoneNoStatus && this.emailStatus && this.usernameStatus && this.passwordStatus);
    },
    customerGroupStatus() {
      return this.usersCreateForm.customerGroup !== '';//'Select Group';
    },
    phoneNoStatus() {
      return this.usersCreateForm.phoneNo.length >= 10
    },
    emailStatus() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.usersCreateForm.email).toLowerCase())
    },
    usernameStatus() {
      return (this.usersCreateForm.username.length > 0 && !this.usersCreateForm.username.includes(' '));
    },
    passwordStatus() {
      return !!(this.passwordLength && this.passwordUppercase && this.passwordNumber && this.passwordCharacter);
    },
    passwordLength() {
      return this.usersCreateForm.password.length > 7
    },
    passwordUppercase() {
      let pass = this.usersCreateForm.password;
      for (let i = 0; i < pass.length; i++) {
        if ('A' <= pass[i] && pass[i] <= 'Z') {
          return true;
        }
      }
    },
    passwordNumber() {
      let pass = this.usersCreateForm.password;
      for (let i = 0; i < pass.length; i++) {
        if ('0' <= pass[i] && pass[i] <= '9') {
          return true;
        }
      }
    },
    passwordCharacter() {
      let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
      if (format.test(this.usersCreateForm.password)) {
        return true
      }
    }
  },
  data() {
    return {
      usersCreateForm: {
        customerGroup: '',//'Select Group',
        isReadOnly: false,
        phoneNo: '',
        email: '',
        username: '',
        password: '',
        name: ''
      },
      groupOption: [],
      enabledCountryCodeStatus: true,
      dialCode: '',
      customerIdentifier: '',
      editStatus: false,
      preferredCountry: 'us',
      validCharactersOnly: true,
      submitLoading: false
    }
  },
  mounted() {
    this.getSelectGroup();
  },
  methods: {

    getSelectGroup() {
      administratorService.getGroupList().then(res => {
        this.groupOption.push({
          key: '',
          label: '[ Select ]'
        });
        res.map((item, index) => {
          let name = String(item.GroupName);
          // console.log('group:'+name,item);
          if (name.toUpperCase().includes('CARRIER_') || name.toUpperCase().includes('ADMINISTRATOR')) {
            if ( name.includes('CARRIER_')) name = name.replace('CARRIER_','');
            this.groupOption.push({key: item.GroupName, label: name,});
          }
        })
      })
    },

    modalClose() {
      this.$bvModal.hide('add-user')
    },

    async usersCreateSubmit() {

      if (this.customerGroupStatus && this.phoneNoStatus && this.emailStatus && this.usernameStatus && this.passwordStatus) {
        this.submitLoading = true;

        //fix phoneumber to be valid, remove all char but numbers and add plus
        let phoneNum = this.usersCreateForm.phoneNo.replace(/[^0-9]+/g, '');
        if (phoneNum.length < 11) phoneNum = '1' + phoneNum;
        phoneNum = '+' + phoneNum;

        this.usersCreateForm.phoneNo = this.dialCode + this.usersCreateForm.phoneNo.replace('(', '').replace(')', '').trim();
        let data = btoa(
          this.usersCreateForm.username + '|' + this.usersCreateForm.email + '|' +
          phoneNum + '|' + this.usersCreateForm.password
        );
        //register user
        await administratorService.registerUser(data).then(async res => {
          let {type, msg} = handleResponse.apiResponse(res);

          if (JSON.stringify(msg).toLowerCase().includes('user already exists')) {
            this.$toast("FAIL - User name already exists", {type: type});
            this.submitLoading = false;
            return
          }
          
          this.$toast(msg, {type: type})

          if (type === 'error') {
            this.submitLoading = false;
           return
          }
          
          //add display name
          const userArttributes = [
            {Name: 'name', Value: this.usersCreateForm.name},
            {Name: 'email', Value: this.usersCreateForm.email},
            {Name: 'phone_number', Value: phoneNum},
          ];
          await AdministratorService.updateUserProfile(this.usersCreateForm.username, userArttributes).then(async res => {
            let {type, msg} = handleResponse.apiResponse(res);
            this.$toast(msg, {type: type})
            if (type === 'error') {
              this.submitLoading = false;
              return
            }
            //add group permission
            await AdministratorService.addUserToGroup(this.usersCreateForm.username, this.usersCreateForm.customerGroup).then(res => {
              console.log('addUserToGroup:',this.usersCreateForm.customerGroup);
              let {type, msg} = handleResponse.apiResponse(res);
              this.$toast(msg, {type: type})
            });
            this.modalClose();
            this.$root.$emit('getUserList')
          });
        });
      } else {
        this.$root.$emit('danger', 'Please input valid data');
      }
    },


    onSelect({name, iso2, dialCode}) {
      this.dialCode = dialCode
    },
  }
}
</script>
